import React, { useState, useEffect } from "react"
import { linkedParentsApi } from "../../lib/api"
import { useToast } from "../../contexts/ToastContext"

const LinkedParentsList = () => {
  const [parents, setParents] = useState([])
  const [loading, setLoading] = useState(true)
  const toast = useToast()

  useEffect(() => {
    fetchParents()
  }, [])

  const fetchParents = async () => {
    try {
      setLoading(true)
      const data = await linkedParentsApi.list()
      setParents(data.parents || [])
    } catch (err) {
      console.error("Failed to fetch linked parents:", err)
    } finally {
      setLoading(false)
    }
  }

  const handleUnlink = async (parentId, parentName) => {
    if (!confirm(`Are you sure you want to unlink ${parentName}? They will no longer be able to view your assignments.`)) {
      return
    }

    try {
      await linkedParentsApi.unlink(parentId)
      toast.success("Parent unlinked successfully")
      fetchParents()
    } catch (err) {
      toast.error(err.message || "Failed to unlink parent")
    }
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
  }

  if (loading) {
    return (
      <div className="animate-pulse space-y-3">
        <div className="h-16 bg-gray-200 rounded-lg"></div>
      </div>
    )
  }

  if (parents.length === 0) {
    return (
      <p className="text-gray-500 text-sm text-center py-4">
        No parents or guardians linked to your account yet.
      </p>
    )
  }

  return (
    <div className="space-y-3">
      {parents.map((parent) => (
        <div
          key={parent.id}
          className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-indigo-500 flex items-center justify-center text-white font-medium">
              {parent.name?.charAt(0)?.toUpperCase() || parent.email?.charAt(0)?.toUpperCase()}
            </div>
            <div className="min-w-0">
              <p className="font-medium text-gray-900 truncate">{parent.name || "Parent"}</p>
              <p className="text-sm text-gray-500 truncate">{parent.email}</p>
            </div>
          </div>

          <div className="flex items-center gap-3">
            <span className="text-xs text-gray-400">
              Linked {formatDate(parent.linked_at)}
            </span>
            <button
              onClick={() => handleUnlink(parent.id, parent.name || parent.email)}
              className="text-sm text-red-600 hover:text-red-800"
            >
              Unlink
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}

export default LinkedParentsList
